interface APIConfig {
  baseUrl: string;
  useStubs?: boolean;
}

const DEFAULT_CONFIG: APIConfig = {
  baseUrl: '',
  useStubs: false,
};

let globalConfig = { ...DEFAULT_CONFIG };

export const getConfig = () => globalConfig;

export const setConfig = (config: APIConfig) => {
  globalConfig = config;
};
